<!-- (c) TwistedMinds, Gerry Uytdenhouwen - 3 november 2026 -->
<template>
    <div class="orders-filters-v2">
        <div class="orders-filters-v2__row">
            <span class="orders-filters-v2__label">{{ $t('general.period-label') }}</span>
            <div class="orders-filters-v2__segment">
                <v-tooltip bottom v-for="period in periods" :key="period.value">
                    <template v-slot:activator="{ on, attrs }">
                        <button
                            type="button"
                            class="orders-filters-v2__segment-item"
                            :class="{'orders-filters-v2__segment-item--active': deliveryDay === period.value}"
                            v-bind="attrs"
                            v-on="on"
                            @click="$emit('period', period.value)"
                        >{{ $t('general.' + period.label) }}</button>
                    </template>
                    <span>{{ $t('general.' + period.tooltip) }}</span>
                </v-tooltip>
            </div>
            <order-period-fields
                :dates="dates"
                :times="times"
                variant="soft"
                @update:dates="$emit('update:dates', $event)"
                @update:times="$emit('update:times', $event)"
                @change="$emit('time-change')"
            ></order-period-fields>
        </div>
        <div class="orders-filters-v2__row">
            <span class="orders-filters-v2__label">{{ $t('general.show-label') }}</span>
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <div class="orders-filters-v2__switch" v-bind="attrs" v-on="on">
                        <v-switch
                            :input-value="archive"
                            :true-value="1"
                            :false-value="0"
                            :label="$t('general.archive')"
                            color="#1d6f86"
                            dense
                            hide-details
                            class="mt-0 pt-0"
                            @change="$emit('update:archive', $event)"
                        ></v-switch>
                    </div>
                </template>
                <span>{{ $t('general.tt_filter_archive') }}</span>
            </v-tooltip>
            <v-tooltip bottom v-if="vendingEnabled">
                <template v-slot:activator="{ on, attrs }">
                    <div class="orders-filters-v2__switch" v-bind="attrs" v-on="on">
                        <v-switch
                            :input-value="onlyMachine"
                            :true-value="1"
                            :false-value="0"
                            :label="$t('general.machine-only')"
                            color="#1d6f86"
                            dense
                            hide-details
                            class="mt-0 pt-0"
                            @change="$emit('update:only-machine', $event)"
                        ></v-switch>
                    </div>
                </template>
                <span>{{ $t('general.tt_filter_machine_only') }}</span>
            </v-tooltip>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        text
                        small
                        color="#1d6f86"
                        class="orders-filters-v2__clear"
                        v-bind="attrs"
                        v-on="on"
                        @click="$emit('clear-all')"
                    >
                        <v-icon left small>mdi-filter-remove-outline</v-icon>
                        {{ $t('general.clear-all-filters') }}
                    </v-btn>
                </template>
                <span>{{ $t('general.tt_filter_clear_all') }}</span>
            </v-tooltip>
        </div>
    </div>
</template>

<script>
import OrderPeriodFields from "./OrderPeriodFields";

export default {
    name: "OrdersFiltersV2",
    components: {OrderPeriodFields},
    props: {
        deliveryDay: {type: String, default: ''},
        archive: {type: Number, default: 0},
        onlyMachine: {type: Number, default: 0},
        vendingEnabled: {type: Boolean, default: false},
        dates: {type: Array, default: () => []},
        times: {type: Array, default: () => []},
    },
    data: () => ({
        periods: [
            {value: 'today', label: 'today', tooltip: 'tt_filter_today'},
            {value: 'yesterday', label: 'yesterday', tooltip: 'tt_filter_yesterday'},
            {value: 'weekly', label: 'this-week', tooltip: 'tt_filter_weekly'},
        ],
    }),
}
</script>

<style scoped lang="scss">
.orders-filters-v2 {
    display: flex;
    flex-direction: column;
    gap: 12px;
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, .06);
    padding: 18px 20px;
    color: #0d3b47;

    .orders-filters-v2__row {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 12px 10px;
    }

    .orders-filters-v2__label {
        flex: 0 0 70px;
        width: 70px;
        color: #6b7a80;
        font-size: 11px;
        font-weight: 600;
        letter-spacing: .05em;
        text-transform: uppercase;
        white-space: nowrap;
    }

    // same height as the Datum/Tijd fields (40px); 24px before the date fields
    .orders-filters-v2__segment {
        display: inline-flex;
        align-items: stretch;
        box-sizing: border-box;
        height: 40px;
        margin-right: 14px;
        gap: 2px;
        padding: 3px;
        background: #f2f4f5;
        border-radius: 9px;
    }

    .orders-filters-v2__segment-item {
        display: inline-flex;
        align-items: center;
        padding: 0 12px;
        border-radius: 7px;
        color: #5d6b70;
        font-size: 13px;
        font-weight: 600;
        white-space: nowrap;
        outline: none;

        &--active {
            background: #fff;
            color: #1d6f86;
            box-shadow: 0 1px 3px rgba(0, 0, 0, .1);
        }
    }

    .orders-filters-v2__switch {
        margin-right: 6px;
    }

    .orders-filters-v2__clear {
        text-transform: none;
        font-weight: 600;
        letter-spacing: normal;
    }
}
</style>
